function assign(obj1, obj2) {
  for (var i in obj2) {
    obj1[i] = obj2[i];
  }
  return obj1;
}
/**
* 检测是否需要发送日志
* @private
* @params {String} target 目标检测节点的CSS选择器
* @params {String|Function} tester 检测方法，支持'HAS_CONTENT"、"EXISTS"、自定义函数
* @return {boolean} true ：需要发送 false：不需要发送
*/
var isBlank = function isBlank(target, tester) {
  try {
    var targetNode = document.querySelector(target);
    var nodeExist;
    if (typeof tester === 'function') {
      // 根据方法判断，返回 true 则存在节点，false 则不存在节点
      nodeExist = tester(targetNode);
    } else if (tester === 'HAS_CONTENT') {
      // HAS_CONTENT 判断节点内容
      nodeExist = targetNode && targetNode.textContent;
    } else {
      // 默认 EXISTS 模式 直接判断节点
      nodeExist = !!targetNode;
    }
    return !nodeExist;
  } catch (e) {}
};
var _test = function _test(config, INITIAL_TIME, etracker) {
  var target = config.target,
    tester = config.tester,
    when = config.when,
    timeout = config.timeout;
  if (!target) {
    return;
  }
  INITIAL_TIME = INITIAL_TIME || Date.now();
  var observers = [];
  var sended;
  var abort = function abort() {
    observers.forEach(function (observer) {
      return observer();
    });
    observers = [];
  };
  var _blankHandler = function _blankHandler(type) {
    try {
      if (!sended && isBlank(target, tester)) {
        etracker.log('blank', {
          p1: type,
          p2: target,
          p3: Date.now() - INITIAL_TIME,
          p4: document.readyState === 'complete',
          p5: timeout
        });
        sended = true;
        abort();
      }
    } catch (e) {}
  };
  when.forEach(function (when) {
    var blankHandler = function blankHandler() {
      _blankHandler(typeof when === 'function' ? 'custom' : when);
    };
    if (when === 'timeout') {
      var sendTimer = setTimeout(blankHandler, timeout - (Date.now() - INITIAL_TIME));
      observers.push(function () {
        sendTimer && clearTimeout(sendTimer);
      });
    } else if (when === 'leave') {
      var vsHandler;
      document.addEventListener('visibilitychange', vsHandler = function vsHandler() {
        if (document.readyState === 'complete' && document.hidden) {
          blankHandler();
        }
      });
      observers.push(function () {
        document.removeEventListener('visibilitychange', vsHandler);
      });
    } else if (when === 'error') {
      var errHandler;
      window.addEventListener('error', errHandler = function errHandler() {
        if (document.readyState === 'complete') {
          blankHandler();
        }
      });
      observers.push(function () {
        window.removeEventListener('error', errHandler);
      });
    } else if (when === 'load') {
      if (document.readyState === 'complete') {
        // 防止直接直接执行导致其他case 不能被销毁掉，例如case为：['error', 'load', 'timeout'], load触发上报后，timeout还会继续执行
        setTimeout(blankHandler, 0);
      } else {
        window.addEventListener('load', blankHandler);
        observers.push(function () {
          window.removeEventListener('load', blankHandler);
        });
      }
    } else if (typeof when === 'function') {
      var observer = when(blankHandler);
      if (typeof observer === 'function') {
        observers.push(observer);
      }
    }
  });
  return abort;
};
function AESPluginBlank(etracker) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _config = assign(assign({
    tester: 'HAS_CONTENT',
    when: ['timeout', 'leave'],
    timeout: 5000
  }, etracker.getConfig('plugin_blank')), config);
  if (_config.autoTest !== false) {
    var _window$performance, _window$performance$t;
    _test(_config, (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$t = _window$performance.timing) === null || _window$performance$t === void 0 ? void 0 : _window$performance$t.navigationStart, etracker);
  }
  return {
    test: function test(config) {
      return _test(assign(assign({}, _config), config), null, etracker);
    }
  };
}

export { AESPluginBlank as default };
